module.exports = __webpack_public_path__ + "img/pic-center.138f1892.svg";